import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Discreet owner entry: the © in the footer opens a tiny passcode box.
export const OwnerAccess = () => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await axios.post(`${API}/admin/login`, { password: code });
      try { sessionStorage.setItem("aip_admin_token", r.data.token); } catch (err) { void err; }
      navigate("/admin");
    } catch {
      setError(true);
    }
  };

  return (
    <span className="relative inline-block">
      <button type="button" onClick={() => setOpen((o) => !o)} className="hover:text-gray-400 transition-colors" data-testid="owner-access-trigger">Owner</button>
      {open && (
        <form onSubmit={submit} className="fixed bottom-28 left-1/2 -translate-x-1/2 md:absolute md:bottom-7 z-50 flex gap-1.5 p-2 rounded-xl bg-black/90 border border-white/10" data-testid="owner-access-form">
          <input
            type="password"
            autoFocus
            value={code}
            onChange={(e) => { setCode(e.target.value); setError(false); }}
            className={`w-32 px-3 py-1.5 rounded-lg bg-white/5 border text-xs text-white focus:outline-none ${error ? "border-rose-500/70" : "border-white/10 focus:border-cyan-400/60"}`}
            aria-label="Passcode" placeholder="Passcode"
            data-testid="owner-access-input"
          />
          <button type="submit" className="px-3 py-1.5 rounded-lg bg-white/10 hover:bg-white/20 text-xs text-white" data-testid="owner-access-submit">→</button>
        </form>
      )}
    </span>
  );
};
